import { ColumnDef } from '@tanstack/react-table'
import { GetPlayerWithWithdrawData } from '@/modules/manage-player/type'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { SortingArrows } from '@/common/components/SortingArrows'
import { PlayerTagsCell } from '@/common/components/PlayerTagsCell'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'
import AssignPlayerTagsModal from '@/modules/manage-player/components/GetPlayerList/components/GetPlayerListTable/CellAction/components/AssignPlayerTagsModal'
import type { PlayerTagResponse } from '@/modules/tags/types'

export const columns: ColumnDef<GetPlayerWithWithdrawData>[] = [
	{
		accessorKey: 'username',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			const { id, username, phone, tags, channel } = row.original
			return (
				<div className="space-y-1">
					<div className="block">
						<UsernameCell username={username} />
					</div>
					<div className="block">
						<PhoneCell playerId={id} phone={phone} />
					</div>
					<div className="block">
						<PlayerTagsCell tags={tags || []} />
					</div>
					<p className="text-xs text-muted-foreground">
						ช่องทาง: {channel?.name || '-'}
					</p>
					<AssignPlayerTagsModal
						playerId={id}
						playerPhone={phone}
						currentTags={tags as unknown as PlayerTagResponse[]}
					/>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalWithdrawAmount',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					ยอดถอนทั้งหมด (บาท)
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const amount = parseFloat(row.getValue('totalWithdrawAmount'))
			return (
				<div className="space-y-1 text-sm">
					<p>ยอดถอน: {amount.toFixed(2)}</p>
					<p className="text-muted-foreground">
						จำนวนถอน: {row.original.totalWithdrawTime || 0} ครั้ง
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'lastOnline',
		header: 'เวลา/การดำเนินการ',
		cell: ({ row }) => {
			const lastOnline = row.original.lastOnline
			return (
				<div className="space-y-1">
					<p className="text-xs text-muted-foreground">
						สมัคร:{' '}
						{new Date(row.original.createdAt).toLocaleDateString('th-TH', {
							year: 'numeric',
							month: '2-digit',
							day: '2-digit',
							hour: '2-digit',
							minute: '2-digit',
							second: '2-digit',
						})}
					</p>
					<p className="text-xs text-muted-foreground">
						ออนไลน์ล่าสุด:{' '}
						{lastOnline
							? new Date(lastOnline).toLocaleDateString('th-TH', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								})
							: '-'}
					</p>
					<Button asChild variant="outline" size="sm">
						<Link
							to={`/operator/get-player-list/player-detail/${row.original.id}`}
						>
							ดูข้อมูลผู้เล่น
						</Link>
					</Button>
				</div>
			)
		},
	},
]
